import api from "./configuration";
import apiUrl from "./url";
import store from "@/store";
// Capture the initiating session; a delayed interceptor must not send an old bundle under a new login.
const request = async (method, path, data, params) => {
	const token = store.getState().token;
	if (!token) throw new Error("Sessione non più attiva.");
	const response = await api.request({
		method,
		url: apiUrl + "/CustomFootballImports" + path,
		data,
		params,
		useAuthInterceptor: false,
		headers: {Authorization: `Bearer ${token}`},
	});
	return response.data;
};
export const CustomFootballImportAPI = {
	searchIdentities: (kind, search) =>
		request("GET", "/identities/search", undefined, {kind, search}),
	options: (seasonId) => request("GET", "/options", undefined, {seasonId}),
	preview: (data) => request("POST", "/preview", data),
	apply: (data) => request("POST", "", data),
	clubPreview: (id, seasonId) =>
		request("GET", "/clubs/" + id + "/preview", undefined, {seasonId}),
	linkPreview: (id, data) =>
		request("POST", "/clubs/" + id + "/link-preview", data),
	link: (id, data) => request("POST", "/clubs/" + id + "/link", data),
};
